export const openSignUp = () => {
    return {type: 'OPEN_SIGN_UP'};
};

export const closeSignUp = () => {
    return {type: 'CLOSE_SIGN_UP'};
};